<template>
    <div class="home">
        <header1></header1>
        <div class="main">
            <div class="banner">
                <div class="swiper1">
                    <van-swipe
                        class="my-swipe"
                        :autoplay="3000"
                        indicator-color="white"
                    >
                        <van-swipe-item
                            ><div class="nav-banner nav-banner1">
                                <div class="box">
                                    <div class="left">
                                        <h2>
                                            <!-- 契合科技<br /> -->
                                            科技契合人性 融合孕育创新
                                        </h2>
                                        <p>
                                            帮助银行等金融机构构建私域流量池，积累了
                                            3000+ 项目经验
                                        </p>
                                        <div>
                                            <a @click="denglu" class="btn btn_hov"
                                                >立即试用</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-swipe-item>
                        <van-swipe-item
                            ><div class="nav-banner nav-banner2">
                                <div class="box">
                                    <div class="left">
                                        <h2>
                                            <!-- 契合科技<br /> -->
                                            领先的私域运营与营销服务专家
                                        </h2>
                                        <p>
                                            提供营销工具，且提供营销规划、活动策划等全链路定制化服务
                                        </p>
                                        <div>
                                            <a @click="denglu" class="btn btn_hovo"
                                                >立即试用</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div></van-swipe-item
                        >
                    </van-swipe>
                </div>
                <div class="contain main-nav">
                    <div class="box">
                        <div>
                            <h2>游戏化营销</h2>
                            <p>酷炫创意，认知渗透</p>
                        </div>
                    </div>
                    <div class="box">
                        <div>
                            <h2>活动模版</h2>
                            <p>多样模版，快速响应</p>
                        </div>
                    </div>
                    <div class="box">
                        <div>
                            <h2>裂变工具</h2>
                            <p>裂变分销，线索跟踪</p>
                        </div>
                    </div>
                    <div class="box">
                        <div>
                            <h2>运营服务</h2>
                            <p>数据复盘、一站服务</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pulic">
                <h2 class="h2-title">契合科技平台</h2>
                <p class="p-subtitle">
                    金融机构一站式营销云解决方案，帮助金融机构打造业绩导向型营销闭环，助力业绩增长。
                </p>
                <div class="contain">
                    <div class="swip-h">
                        <div @click="swiphTabs(0)">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/span1_active.png"
                                v-show="vals == 0 || vals == ''"
                            />
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/span1.png"
                                v-show="vals != 0"
                            />
                        </div>
                        <div @click="swiphTabs(1)">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/span2_active.png"
                                v-show="vals == 1"
                            />
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/span2.png"
                                v-show="vals != 1"
                            />
                        </div>
                        <div @click="swiphTabs(2)">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/span3_active.png"
                                v-show="vals == 2"
                            />
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/span3.png"
                                v-show="vals != 2"
                            />
                        </div>
                        <div @click="swiphTabs(3)">
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/span4_active.png"
                                v-show="vals == 3"
                            />
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/span4.png"
                                v-show="vals != 3"
                            />
                        </div>
                    </div>
                    <div class="swiper2">
                        <van-swipe
                            :show-indicators="false"
                            class="my-swipe"
                            :autoplay="3000"
                            @change="onChange"
                            indicator-color="white"
                            ref="mySwiper"
                        >
                            <van-swipe-item>
                                <div class="box">
                                    <div class="left">
                                        <img
                                            src="https://hdimg.kerlala.com/hd/website/urthink/jiejue1.png"
                                            class="img"
                                        />
                                    </div>
                                    <div class="right">
                                        <h2>企业微信SCRM</h2>
                                        <p>
                                            契合科技企业微信SCRM是一款企业微信的客户营销管理工具：基于企业微信官方端口的营销管理系统，帮助客户最大化利用企业微信的营销功能，打造触达&gt;拓客&gt;活客&gt;转化&gt;裂变营销全流程闭环。触达&gt;拓客&gt;活客&gt;转化&gt;裂变营销全流程闭环。
                                        </p>
                                        <a @click="denglu" class="btn"
                                            >立即试用</a
                                        >
                                    </div>
                                </div>
                            </van-swipe-item>

                            <van-swipe-item>
                                <div class="box">
                                    <div class="left">
                                        <img
                                            src="https://hdimg.kerlala.com/hd/website/urthink/jiejue2.png"
                                            class="img"
                                        />
                                    </div>
                                    <div class="right">
                                        <h2>营销活动模版</h2>
                                        <p>
                                            活动模板多、玩法丰富，系统稳定，提供标准云平台服务；同时可以OEM，集成到银行及其他行业系统，快速响应业务需求，助您⾼效拓客转化。&nbsp;触达&gt;拓客&gt;活客&gt;转化&gt;裂变营销全流程闭环。
                                        </p>
                                        <a @click="denglu" class="btn"
                                            >立即试用</a
                                        >
                                    </div>
                                </div></van-swipe-item
                            >
                            <van-swipe-item
                                ><div class="box">
                                    <div class="left">
                                        <img
                                            src="https://hdimg.kerlala.com/hd/website/urthink/jiejue3.png"
                                            class="img"
                                        />
                                    </div>
                                    <div class="right">
                                        <h2>H5快易搭</h2>
                                        <p>
                                            具有海量银行业务&amp;营销场景模版，适用于活动邀约、品牌展示、数据管理、产品促销等场景；内设各种类型组件、素材库，专业帮助您从选题制作到传播运营，0
                                            基础快速创建 H 5
                                            页面。&gt;拓客&gt;活客&gt;转化&gt;裂变营销全流程闭环。
                                        </p>
                                        <a @click="denglu" class="btn"
                                            >立即试用</a
                                        >
                                    </div>
                                </div></van-swipe-item
                            >
                            <van-swipe-item
                                ><div class="box">
                                    <div class="left">
                                        <img
                                            src="https://hdimg.kerlala.com/hd/website/urthink/jiejue4.png"
                                            class="img"
                                        />
                                    </div>
                                    <div class="right">
                                        <h2>推客裂变平台</h2>
                                        <p>
                                            将银行等金融机构的所有员工、商家渠道、第三方合作机构人员转化为有效的社会化营销节点，业绩可追溯，奖励可跟踪，有效激励推客人员，形成良性决策动力。触达&gt;拓客&gt;活客&gt;转化&gt;裂变营销全流程闭环。
                                        </p>
                                        <a @click="denglu" class="btn"
                                            >立即试用</a
                                        >
                                    </div>
                                </div></van-swipe-item
                            >
                        </van-swipe>
                    </div>
                </div>
            </div>
            <div class="pulic marketing">
                <h2 class="h2-title">做营销，找契合科技</h2>
                <p class="p-subtitle">
                    我们提供⾦融行业私域流量运营的最佳实践，包括客户营销、活动策划、运营实施等全流程解决方案。
                </p>
                <div class="contain">
                    <ul class="active-box">
                        <li>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/shuju1.png"
                                class="icon"
                            />
                            <h3>活动策划</h3>
                            <p>
                                量身定制的金融机构营销方案，打造您的专属营销方法，一对一定制独具匠心的活动创意与落地执行规划。
                            </p>
                        </li>
                        <li>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/shuju2.png"
                                class="icon"
                            />
                            <h3>运营服务</h3>
                            <p>
                                提供专业运营服务，包含参数配置，权益数字化发放、达标查询、数据日报、活动总结等活动运营全流程。
                            </p>
                        </li>
                    </ul>
                    <ul class="active-box">
                        <li>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/shuju3.png"
                                class="icon"
                            />
                            <h3>视觉设计</h3>
                            <p>
                                结合目标人群、营销场景及营销时节等因素，推出具有吸引力的页面设计与用户体验方案。
                            </p>
                        </li>
                        <li>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/shuju4.png"
                                class="icon"
                            />
                            <h3>数据分析</h3>
                            <p>
                                依据可视化的实时数据看板和用户多渠道反馈分析，及时跟进运营服务调整，推动活动的迭代优化。
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="pulic case">
                <h2 class="h2-title">契合科技案例精选</h2>
                <p class="p-subtitle">
                    近年来，契合科技系列产品服务于国内各大中小银行，输出很多成功的产品及服务案例
                </p>
                <div class="casebox">
                    <ul>
                        <li>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/case1.png"
                                class="img"
                            /><img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/case1_logo.png"
                                class="logo"
                            />
                            <h3>建设银行数字化营销</h3>
                            <p>
                                打造国有大行数字化营销新模式：主题会场+客群活动两手抓，上亿流量及千万奖池规模，助力业务指标转化！
                            </p>
                        </li>
                        <li>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/case2.png"
                                class="img"
                            /><img src="../../assets/ICBc.png" class="logo" />
                            <h3>工商银行</h3>
                            <p>
                                MGM裂变营销平台，提供MGM活动制作、发布、权益激励、分支行业绩统计近5年来，助力于平台迭代与运维，累计开展活动上千场，获客人数百万以上
                            </p>
                        </li>
                        <li>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/case3.png"
                                class="img"
                            /><img src="../../assets/xyyh.png" class="logo" />
                            <h3>兴业银行</h3>
                            <p>
                                契合科技营销平台进行私有化部署，丰富了行内系统的营销形式和内容，与行内业务数据实现互通，成为运营营销工作有力的抓手。
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="text">
                    通过提供新型的数据化运营工具，帮助客户解决设计、创意、技术、活动等问题；通过自营数据化流量和全网流量整合，帮助客户快速触及海量用户
                </div>
            </div>
            <div class="pulic customer">
                <h2 class="h2-title">我们的客户</h2>
                <p class="p-subtitle">
                    截止到目前，已服务超过30多家优秀金融机构，已经在业界形成良好口碑。
                </p>
                <div class="kehucase">
                    <img src="../../assets/kehu.png" class="customerImg" />
                </div>
            </div>
        </div>
        <div class="footer">
            <bgred></bgred>
            <contain></contain>
        </div>
    </div>
</template>

<script>
import header1 from "../../components/header1.vue";
import bgred from "../../components/bgred.vue";
import contain from "../../components/contain.vue";
export default {
    data() {
        return {
            vals: 0,
        };
    },
    components: { header1, bgred, contain },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    methods: {
        nolond() {},
        onChange(val) {
            this.vals = val;
            // console.log(this.vals);
        },
        swiphTabs(index) {
            this.vals = index;
            this.$refs.mySwiper.swipeTo(index);
        },
        denglu() {
            this.$router.push({
                path: "/login",
            });
        },
    },
};
</script>
<style scoped>
@import "../../../static/chunk-vendors.css";
.casebox ul {
    margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/views/slg/index.vue